<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Case Converter</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="sentence()">Sentence case</v-btn>
            <v-btn color="primary" @click="lowercase()">Lower case</v-btn>
            <v-btn color="primary" @click="uppercase()">Upper Case</v-btn>
            <v-btn color="primary" @click="capitalize()">Capitalize case</v-btn>
            <v-btn color="primary" @click="decapitalize()">Decapitalize case</v-btn>
            <v-btn color="primary" @click="camel()">Camel case</v-btn>
            <v-btn color="primary" @click="kebab()">Kebab case</v-btn>
            <v-btn color="primary" @click="snake()">Snake case</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import v from 'voca'

export default {
  data: () => ({
    text: '',
    result: ''
  }),
  methods: {
    sentence() {
      let space = this.text.match(/^\s*/)[0].length
      let result = v.splice(this.text, 0, space)
      result = v.capitalize(result)
      result = `${' '.repeat(space)}${result}`
      this.result = result
    },
    lowercase() {
      this.result = this.text.toLowerCase()
    },
    uppercase() {
      this.result = this.text.toUpperCase()
    },
    capitalize() {
      this.result = v.titleCase(this.text)
    },
    decapitalize() {
      this.result = v.decapitalize(this.text)
    },
    camel() {
      this.result = v.camelCase(this.text)
    },
    kebab() {
      this.result = v.kebabCase(this.text)
    },
    snake() {
      this.result = v.snakeCase(this.text)
    }
  }
}
</script>

<style>
</style>